import { useState } from "react";
import useAxios from "./useAxios";
import { TError } from "../../types/common";

type DownloadDataParams = {
  api: string;
  params?: any;
  id?: number;
  filename?: string;
  isExternal?: boolean;
};

const useDownload = () => {
  const [downloading, setDownloading] = useState(false);
  const [error, setError] = useState<TError>({});
  const [success, setSuccess] = useState(false);
  const [data, setData] = useState<any>();
  const { downloadBlob } = useAxios();

  const downloadFile = (options: DownloadDataParams) => {
    const { api, params, id, filename, isExternal } = options;

    // If id is passed, append to API endpoint
    setError({});
    setSuccess(false);
    setDownloading(true);

    downloadBlob({
      api: id ? `${api}${id}/` : api,
      loader: setDownloading,
      errorHandler: setError,
      successHandler: (res: any) => {
        setData(res);
        setSuccess(true);
      },
      params,
      filename,
      isExternal,
    });
  };

  const updateErrors = (err: TError) => {
    setError(err ? { ...error, ...err } : {});
  };

  const resetState = () => {
    setError({});
    setSuccess(false);
    setData(null);
  };

  return {
    downloading,
    error,
    data,
    success,
    downloadFile,
    updateErrors,
    setError,
    setSuccess,
    resetState,
  };
};

export default useDownload;
